export function titleSplit(title: string | null, part = false): string {
    if (title !== null) {
        const wordsList: string[] = title.split(" ");
        const wordsListLength = wordsList.length;
        const firstHalfTitle = wordsList.slice(0, wordsListLength / 2).join(" ")
        const secondHalfTitle = wordsList.slice((wordsListLength / 2)).join(" ")
        return part ? secondHalfTitle : firstHalfTitle;
    } else {
        return "";
    }
}